import { db } from "../../../config/firebase/firebase-config";

export const getCountriesTwo = async () => {
    const dosSnap = await db.collection("country").orderBy("name_es", "asc").get();
    const response: any[] = [];
  
    dosSnap.forEach((doc) => {
      response.push({ id: doc.id, ...doc.data() });
    });
  
    return response;
  };
  
  
  export const getStatesTwo = async (countryId: string) => {
    const statesSnap = await db
      .collection("country")
      .doc(countryId.toString())
      .collection("states")
      .get();
    const states: any[] = [];
  
    statesSnap.forEach((doc) => {
      states.push({ id: doc.id, ...doc.data() });
    });
  
    return states;
  };
  
  export const getCitiesTwo = async (idContry: string, idState: string) => {
    const cities = await db
      .collection("country")
      .doc(idContry.toString())
      .collection("states")
      .doc(idState.toString())
      .collection("cities")
      .get();
    const response: any[] = [];
  
    cities.forEach((doc) => {
      response.push({ id: doc.id, ...doc.data() });
    });
  
    return response;
  };
  